<template>
    <div class="mt-4 mt-lg-0">
        <div v-for="navItem in menuList.menuItems"
             :key="navItem.displayText" class="mb-4">

            <h6 class="text-uppercase">{{navItem.displayText}}</h6>
            <p v-for="navLinks in navItem.menuItemsList.menuItems"
               :key="navLinks.displayText" class="mb-1">
                <a target="_top" :href="navLinks.linkMenuItem.url">{{navLinks.displayText}}</a>
            </p>

        </div>
    </div>
</template>

<script>
    import gql from 'graphql-tag';

    export default {
        data() {
            return {
                menuList: [],
            };
        },
        computed: {
            getMenu() {
                return this.menu[0].menuItemsList;
            },
        },
        watch: {
            menu: {
                handler() {
                    this.menuList = this.getMenu;
                }
            }
        },
        apollo: {
            menu: {
                query: gql`
                    {
                      menu(where: {displayText: "Footer Menu"}) {
                        menuItemsList {
                          menuItems {
                            ... on LinkMenuItem {
                              linkMenuItem {
                                url
                              }
                              displayText
                            }
                            menuItemsList {
                              menuItems {
                                ... on LinkMenuItem {
                                  linkMenuItem {
                                    url
                                  }
                                  displayText
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                `,
            }
        },
    };
</script>